import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
import { ModalOpenButton } from "../modal/ModalOpenButton.js";
import { makeStyles } from "../styles.js";
import { Image } from "./Image.js";
export const ImageWithPreview = ({ title, loading, disabled, handleDelete, borderRadius, style, renderDeleteButton, ...imgAttributes }) => {
    const { isMinTablet } = useScreenWidth();
    const image = (_jsx(Image, { title: title, loading: loading, disabled: disabled, handleDelete: handleDelete, borderRadius: borderRadius, style: { ...style, cursor: "pointer" }, renderDeleteButton: renderDeleteButton, ...imgAttributes }));
    // no need to show modal dialog for mobile devices
    return isMinTablet ? (_jsx(ModalOpenButton, { Modal: ImageDialog, modalProps: { ...imgAttributes, title }, children: image })) : (image);
};
const ImageDialog = ({ handleClose, title, style, ...imgAttributes }) => {
    const { classes } = useStyles();
    return (_jsx(Dialog, { open: true, onClose: handleClose, classes: classes, maxWidth: "md", children: _jsx("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }, children: _jsx("img", { alt: title, ...imgAttributes, style: { objectFit: "contain", maxWidth: "100%", maxHeight: "100%" } }) }) }));
};
const useStyles = makeStyles()({
    paper: {
        border: "none",
        backgroundColor: "transparent",
    },
});
//# sourceMappingURL=ImagePreview.js.map